
<div class="h-full w-full flex flex-col gap-4">
    <div class="w-full flex flex-row items-center gap-2">
        <div class="relative flex-grow">
            <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                <lucide-icon [img]="icons.Search"></lucide-icon>
            </div>
            <input 
                type="search" 
                class="block w-full p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500" 
                [(ngModel)]="searchQuery" 
                (input)="filterAssessCases()"
                placeholder="Search Assessment Case..."  />
        </div>
        <select
            class="w-44 p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
            [(ngModel)]="caseTypeFilter"
            (ngModelChange)="filterAssessCases()"
            aria-label="Case type"
        >
            <option value="all">All cases</option>
            <option value="internal">Internal cases</option>
            <option value="external">External cases</option>
        </select>
    </div>
    <div class="h-full pb-4 overflow-y-auto">
        <ng-container *ngIf="filteredClosingCases.length > 0; else emptyClosingCases">
            <table class="w-full text-left">
                <thead class="oswald-font text-gray-700 uppercase bg-main-background">
                    <tr>
                        <th scope="col" class="px-4 py-3 w-14">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                No.
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3 min-w-40">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                Case No.
                                <lucide-icon
                                    (click)="sortList('case_id')"
                                    [img]="icons.ArrowUpDown" size="18"
                                ></lucide-icon>
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3 min-w-96">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                Summary
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3 w-44 min-w-32">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                Created At
                                <lucide-icon
                                    (click)="sortList('created')"
                                    [img]="icons.ArrowUpDown" size="18"
                                ></lucide-icon>
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3 w-40 min-w-32">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                Created By
                                <lucide-icon
                                    (click)="sortList('created_by_name')"
                                    [img]="icons.ArrowUpDown" size="18"
                                ></lucide-icon>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let case of filteredClosingCases | paginate: { itemsPerPage: itemsPerPage, currentPage: page }; let i=index;" class="bg-white border-b">
                        <th scope="row" class="px-4 py-4">
                            {{ (i + 1) + ((page - 1) * itemsPerPage) }}
                        </th>
                        <th class="px-4 py-4 font-medium text-gray-900 whitespace-nowrap">
                            {{ case.case_id }}
                        </th>
                        <td class="px-4 py-4 whitespace-pre-line">
                            <div *ngIf="case.is_uploaded; else situationSummary" class="flex flex-col gap-0.5">
                                <span class="italic text-nside-gray-200">External case (uploaded files)</span>
                                <span class="text-sm">
                                    Full Team Threat Assessment required:
                                    <span *ngIf="case.full_team_required === 1" class="font-semibold">Yes</span>
                                    <span *ngIf="case.full_team_required === 0" class="font-semibold">No</span>
                                    <span *ngIf="case.full_team_required == null" class="italic text-nside-gray-200">Not answered yet</span>
                                </span>
                            </div>
                            <ng-template #situationSummary>{{ case.detail_of_situation }}</ng-template>
                        </td>
                        <td class="px-4 py-4">{{ case.created | date: 'MM/dd/yyyy - HH:mm' }}</td>
                        <td class="px-4 py-4">{{ case.created_by_name }}</td>
                    </tr>
                </tbody>
            </table>
        </ng-container>
    
        <ng-template #emptyClosingCases>
            <div class="w-full text-nside-gray-100 italic">
                Empty Closed Cases
            </div>
        </ng-template>
    </div>
    <div class="flex justify-between items-center">
        <p>{{ filteredClosingCases.length }} in total</p>
        <pagination-controls
            *ngIf="filteredClosingCases.length > itemsPerPage"
            (pageChange)="page = $event"
            previousLabel="Prev"
            nextLabel="Next"
            class="mt-2"
        ></pagination-controls>
    </div>
</div>

<popup-message 
    [type]="messageModal"
    [message]="popupMessage"
    (close)="resetMessageModal()"
></popup-message>

<div *ngIf="loading">
    <spinner></spinner>
</div>
